import { useMemo } from "react";
import { Link } from "react-router-dom";
import DataTable from "./DataTable";
import SplitNumber from "../_Components/SplitNumber";
import _ from "lodash";
import { useLocation } from "react-router-dom";
import { ViewModal } from "./ViewModal";

function DataGrid({ data }) {
  let location = useLocation();
  // const handleChange = (name) => (event) => {
  //   callApiService(name);
  // };
  // async function callApiService(item) {
  //   const response = await ApiAmusementTestimonial.updateAmusementTestimonialStatus({
  //     id: item.id,
  //     status: !item.status,
  //   });
  //   if (response.succeeded == true) document.getElementById("submitButton").click();

  //   SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  // }

  // async function deleteApi(item) {
  //   const response = await ApiAmusementTestimonial.deleteAmusementTestimonial({ id: item.id });
  //   if (response.succeeded == true) document.getElementById("submitButton").click();
  //   SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  // }

  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "#",
      minWidth: 50,
    },
    {
      accessor: "createdFullName",
      Header: "نام-نام خانوادگی",
      minWidth: "100px",
    },
    {
      accessor: "phoneNumber",
      Header: "شماره تماس",
      minWidth: "100px",
    },
    {
      Header: "قیمت اصلی",
      minWidth: 100,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center success">
          <SplitNumber number={row.original.originalPrice} />
        </div>
      ),
    },
    {
      Header: "قیمت",
      minWidth: 100,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center success">
          <SplitNumber number={row.original.price} />
        </div>
      ),
    },
    {
      accessor: "statusS",
      Header: "وضعیت",
      minWidth: 100,
    },

    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: 90,
      maxWidth: 90,
      align: "center",
    },

    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* نمایش */}
          <Link
            variant="success"
            title="ویرایش"
            to={`/ViewNewBasketContents/${row.original.id}`}
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
          >
            <i className="far fa-edit text-small"></i>
          </Link>
        </div>
      ),
    },
  ]);
  const config = useMemo(() => ({
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  }), []);
  return (
    <div>
      {!_.isEmpty(location.state) && _.isNumber(location.state?.id) ? <ViewModal /> : <></>}

      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
